/* __next_internal_client_entry_do_not_use__ default auto */ import useForkRef from '@mui/utils/useForkRef';
export default useForkRef;
